AOS.init();

// fancy header
const hrContainers = document.querySelectorAll('.hr-container');
        
window.addEventListener('scroll', () => {
    hrContainers.forEach(container => {
        const rect = container.getBoundingClientRect();
        const hrWidth = container.offsetWidth;
        const windowHeight = window.innerHeight;
        
        let scrollPercent;
        if (rect.top < windowHeight / 2) {
            scrollPercent = 1;
        } else {
            scrollPercent = Math.max(0, (windowHeight - rect.top) / (windowHeight / 2));
        }

        const circle = container.querySelector('.circle');
        const circlePosition = scrollPercent * hrWidth;
        circle.style.left = `${circlePosition}px`;
    });
});